import { useCallback } from 'react'
import type { CsvRendererProps } from '../types'

export function CsvRenderer({ content, delimiter, hasHeader }: CsvRendererProps) {
  const parseCSV = useCallback((csv: string, delim: string): string[][] => {
    const lines = csv.split('\n').filter(line => line.trim())
    return lines.map(line => {
      const cells: string[] = []
      let current = ''
      let inQuotes = false

      for (let i = 0; i < line.length; i++) {
        const char = line[i]

        if (char === '"') {
          inQuotes = !inQuotes
        } else if (char === delim && !inQuotes) {
          cells.push(current.trim())
          current = ''
        } else {
          current += char
        }
      }
      cells.push(current.trim())
      return cells
    })
  }, [])

  const csvData = parseCSV(content, delimiter)
  const headers = hasHeader && csvData.length > 0 ? csvData[0] : []
  const rows = hasHeader ? csvData.slice(1) : csvData

  return (
    <div className="flex-1 min-h-0 flex flex-col rounded-lg border overflow-hidden" style={{ backgroundColor: 'var(--sidebar-background)', borderColor: 'var(--sidebar-border)' }}>
      <div className="file-preview-content flex-1 overflow-auto">
        <div className="p-4">
          <div className="overflow-x-auto">
            <table className="file-preview-csv-table w-full border-collapse text-sm">
              {hasHeader && headers.length > 0 && (
                <thead>
                  <tr style={{ borderBottomColor: 'var(--window-border-color)' }} className="border-b-2">
                    {headers.map((header, idx) => (
                      <th
                        key={idx}
                        className="px-4 py-2 text-left font-semibold first:rounded-tl-lg last:rounded-tr-lg"
                        style={{
                          backgroundColor: 'var(--window-background)',
                          color: 'var(--text-color)'
                        }}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
              )}
              <tbody>
                {rows.map((row, rowIdx) => (
                  <tr
                    key={rowIdx}
                    className="border-b transition-colors hover:opacity-80"
                    style={{ borderBottomColor: 'var(--window-border-color)' }}
                  >
                    {row.map((cell, cellIdx) => (
                      <td
                        key={cellIdx}
                        className="px-4 py-2"
                        style={{ color: 'var(--text-color)' }}
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
